export default "__VITE_ASSET__D_YPQ2k3__"